import React from 'react';
// migrated from makeStyles to MUI v5 `sx` props
// Button removed to avoid nested button rendering inside IconButton
import TouchAppIcon from "@mui/icons-material/TouchApp";
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import TransitionsPopper from "./Popper"
import LoadingImage from '../LoadingImage';


const sxRoot = { maxWidth: 600 };
const sxMedia = { height: 0, pt: '56.25%' };
const sxAvatar = { bgcolor: '#000c66' };

export default function SingleRecipe(prop) {
  
  const handleChildClick = (e) =>{
    e.stopPropagation();
  }

  return (
  <Card sx={sxRoot} style={{backgroundColor:"#a4e5e0"}}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" sx={sxAvatar}>
            {prop.name[0]}
          </Avatar>
        }
        action={
          <IconButton aria-label="settings">
            <MoreVertIcon />
          </IconButton>
        }
        title={prop.name}
        subheader={prop.noIngredients + "  Ingredients"}
      />
      <LoadingImage
        sx={sxMedia}
        src={prop.image}
        alt={prop.name}
      />
      <CardContent>
        <Typography variant="body2" color="textSecondary" component="p">
          {prop.description}
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
        <IconButton aria-label="add to favorites">
          {/* Replace nested Button with a non-button inline element to avoid nested <button> warnings */}
          <Typography component="span" variant="body2" color="textSecondary" sx={{display: 'inline-flex', alignItems: 'center'}}>
            Try recipe <TouchAppIcon sx={{ ml: 0.5 }} />
          </Typography>
        </IconButton>
        <IconButton style={{marginBottom: "7px"}}    onClick={(e)=>handleChildClick(e)} aria-label="share">
         <TransitionsPopper id={prop.id}/> 
        </IconButton>
      </CardActions>

    </Card>
  );
}
